export class BlipBucketService {
    static $inject = ['BlipService'];
    constructor(BlipService) {
        this.BlipService = BlipService;
    }
    async set(bucket, resource, type = 'application/json', expiration) {
        let uri = `/buckets/${encodeURIComponent(bucket)}`;
        if (expiration) {
            uri = `${uri}?expiration=${expiration}`;
        }
        return await this.BlipService.processCommand({
            method: 'set',
            type: type,
            uri: uri,
            resource,
        });
    }
    async get(bucket, take = 100) {
        return await this.BlipService.processCommand({
            method: 'get',
            uri: `/buckets/${bucket}?$take=${take}`,
        });
    }
    async delete(bucket) {
        return await this.BlipService.processCommand({
            method: 'delete',
            uri: `/buckets/${bucket}`,
        });
    }
}
BlipBucketService.$inject = ['BlipService'];
